import { Dialog, DialogContent } from "@mui/material";
import React, { FC } from "react";
import FileUpload from "components/FileUpload";

interface UploadProps {
  handleClose: () => void;
  open: boolean;
  widgetName?: string;
}

const UploadModal: FC<UploadProps> = ({ handleClose, open, widgetName }) => {
  return (
    <Dialog
      sx={{
        "& .MuiDialog-container MuiDialog-scrollPaper css-hz1bth-MuiDialog-container":
          {
            background: "rgba(0,0,0,0.7)",
          },
      }}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableEscapeKeyDown
    >
      <DialogContent
        sx={{
          width: "444px",
          padding: "24px",
        }}
      >
        <FileUpload
          handleClose={handleClose}
          closeUploadModal={(close) => {
            if (!close) handleClose();
            else {
              if (widgetName === "RangerFBA") handleClose();
              else window.location.reload();
            }
          }}
          widgetName={widgetName}
        />
      </DialogContent>
    </Dialog>
  );
};

export default UploadModal;
